import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import InvestingEntityType from 'src/app/dashboard/models/InvestingEntityType.enum';

@Component({
  selector: 'terra-investing-entity-chip',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [
    `
      .shared-entity {
        display: flex;
        background: none;
        border: 1px solid #B8BCC7;
        gap: 8px;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        padding-left: 4px;

        mat-icon.avatar-icon {
          background-color: #EBECFD;
          border-radius: 50%;
          padding: 4px;
          display: flex;
        }
      }
    `,
  ],
  template: `
    <mat-chip-row (removed)="onRemove()" class="shared-entity" [disableRipple]="!this.active">
      <mat-icon [svgIcon]="InvestingEntityType.getIcon(investingEntity.investingEntityType)" class="avatar-icon"></mat-icon>
      {{ investingEntity.name }}
      <button matChipRemove *ngIf="active">
        <mat-icon>close</mat-icon>
      </button>
    </mat-chip-row>
  `,
})
export class InvestingEntityChipComponent {
  @Input() investingEntity!: {
    id: number;
    investingEntityType: InvestingEntityType;
    name: string;
  };
  @Input() active = true;
  @Output() remove = new EventEmitter();

  InvestingEntityType = InvestingEntityType;

  onRemove() {
    if (!this.active) {
      return;
    }
    this.remove.emit(this.investingEntity);
  }
}
